import { type ReactElement, type ReactNode } from 'react';
import { KeyValue } from '@vello/web-theme';

/** A short value that is a number, an amount, a date, a version or an id: it has a digit and no word of four letters. */
function looksLikeData(value: string): boolean {
  return /\d/.test(value) && !/\p{L}{4,}/u.test(value);
}

/**
 * One label / value row of a record, on the shared `KeyValue` (audit admin #10: ten near-identical local `Row`s, every
 * one of them setting the value in the mono face — even a sentence or a name). The value is the children or `value`;
 * the mono face (`tnum`) is used only for a value that is data: a number, an amount, a time, an id. Pass `mono` to
 * decide it yourself (money and ids: `true`; a name or a sentence: `false`).
 */
export function DetailRow({ label, value, children, mono }: { label: ReactNode; value?: ReactNode; children?: ReactNode; mono?: boolean }): ReactElement {
  const raw = children ?? value;
  const content = raw === undefined || raw === null || raw === '' ? '—' : raw;
  const isMono = mono ?? (typeof content === 'string' && looksLikeData(content));
  return (
    <KeyValue label={label} mono={isMono}>
      {content}
    </KeyValue>
  );
}
